import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { useHistory } from 'react-router-dom';
import { useUpdateEffect } from "@/hooks/useUpdateEffect";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { isValidIP, getParameterByName } from "@/utils/utils";
import Faye from "faye";
import DownCircle from "@/img/down-circle.png";
import TipsSolid from "@/img/tips-solid.png";
import asyncComp from "core/lib/async-comp";
import Conversation from "@/pages/conversation"; // 会话存档
import ConversationFriend from "@/components/conversation-module/iframeBridge"; // crm好友详情页的会话存档
import ConversationNew from "@/pages/conversation-new/conversation-new"; // 会话存档
import ErrorModal from "@/components/modal/ErrorModal";
import { modalFlag } from "@/actions/labelModalFlag";

const NoPermission = asyncComp(() => import("@/routes/pc-check-page/no-permission").then());
const MarketGroup = asyncComp(() => import("@/pages/market/market-group").then()); //群活码
const MarketStaff = asyncComp(() => import("@/pages/market/market-staff").then()); //员工活码
const TrafficCustomer = asyncComp(() => import("@/pages/traffic-customer/traffic-customer").then()); //客户列表
const CustomerDetail = asyncComp(() => import("@/pages/customer/customer-detail").then()); //客户详情
const Welcome = asyncComp(() => import("@/pages/welcome-page/welcome"));
const GroupWelcome = asyncComp(() => import("@/pages/group-welcome/welcome"));
const MenuList = asyncComp(() => import("@/pages/menu-list/menuList"));
const Guidance = asyncComp(() => import("@/pages/guidance/guidance").then()); // 企微助手步骤引导
const Company = asyncComp(() => import("@/pages/message/company").then()); // 企业信息
const ViolationWarnings = asyncComp(() => import("@/pages/message-archives/index").then()); // 违规提醒
const Settings = asyncComp(() => import("@/routes/settings").then()); // 系统设置路由
const OpenInformation = asyncComp(() => import("@/pages/guidance/open-information").then()); // 是否开通会话存档配置
const MessageGuidance = asyncComp(() => import("@/pages/guidance/information-setting").then()); // 会话存档配置页面
const MaterialList = asyncComp(() => import("@/pages/material/material-list").then()); // 文件库
const MaterialRadar = asyncComp(() => import("@/pages/material/material-radar-link").then()); // 营销素材
const Sidebar = asyncComp(() => import("@/pages/sidebar/sidebar")); // 侧边栏
const TechniqueList = asyncComp(() => import("@/pages/technique/technique-list").then()); // 话术库
const TechniquePersonalList = asyncComp(() => import("@/pages/technique/technique-personal-list").then()); // 个人话术库
const GroupList = asyncComp(() => import("@/pages/group-list/group-list")); // 群列表
const GroupDetail = asyncComp(() => import("@/pages/group-list/group-detail")); // 群详情
const MarketDetail = asyncComp(() => import("@/pages/market/market-detail")); // 员工活码详情
const LossReminder = asyncComp(() => import('@/pages/loss-reminder/loss-reminder')); // 流失提醒
const DeleteReminder = asyncComp(() => import('@/pages/delete-reminder/delete-reminder')) // 删人提醒
const InteractRadar = asyncComp(() => import("@/pages/interact-radar/radar-list")); // 营销素材
const MarketClues = asyncComp(() => import("@/pages/market-clues/market-clues")); // 营销线索
const EnterpriseBoard = asyncComp(() => import("@/pages/enterprise-board/enterprise-list")); // 企微看板
const CustomerAnalysis = asyncComp(() => import("@/pages/customer-analysis/customer-analysis")); // SCRM分析
const ToolCenter = asyncComp(() => import("@/pages/tool-center")); // SCRM工具
const SopList = asyncComp(() => import("@/pages/standard-operating/sop-list"))
const StandardOperatingDetail = asyncComp(() => import("@/pages/standard-operating/standard-operating-detail")); // SOP详情
const StandardOperatingSave = asyncComp(() => import("@/pages/standard-operating/standard-operating-save")); // SOP保存
const QwAssistant = asyncComp(() => import("@/pages/qw-assistant/qw-assistant")); // 企微助手
const MessageReplyList = asyncComp(() => import("@/pages/message-reply/index")); // 消息回复
const BatchAddFriendList = asyncComp(() => import("@/pages/batch-add-friend/batch-add-friend-list")); // 批量添加好友
const CardApplet = asyncComp(() => import("@/pages/card-applet/card-applet")); // 智能名片
const SmartCode = asyncComp(() => import("@/pages/smart-code/smart-code")); // 智能码
const SmartCodeDetail = asyncComp(() => import("@/pages/smart-code/smart-code-detail")); // 智能码详情
const RemindCustomerDetail = asyncComp(() => import("@/pages-h5/sop-remind/remind-customer-detail").then())
const MassAssistantList = asyncComp(() => import("@/pages/mass-assistant/mass-assistant-list")); // 群发助手
const MassAssistantDetail = asyncComp(() => import("@/pages/mass-assistant/mass-assistant-detail")); // 群发任务
const PotentialLeads = asyncComp(() => import("@/pages/potential-leads/potential-leads")); // 潜在线索
const ThirdGuide = asyncComp(() => import("@/pages/third-guide/third-guide")) // 第三方应用引导
const BatchAddFriendDetail = asyncComp(() => import("@/pages/batch-add-friend/batch-add-friend-detail").then()); // 批量添加好友详情
const BatchAddFriendGuide = asyncComp(() => import("@/pages/batch-add-friend/batch-add-friend-guide"))
const AICreate = asyncComp(() => import("@/pages/interact-radar/ai-create/index.jsx"))
const ThirdConversationList = asyncComp(() => import("@/pages-h5/thirdConversation/index")) // 会话存档-用户列表
const ThirdConversationUserDetailList = asyncComp(() => import("@/pages-h5/thirdConversation/user-detail-list")) // 会话存档-用户详情列表
const ThirdConversationChatDetailList = asyncComp(() => import("@/pages-h5/thirdConversation/chat-detail-list")) // 会话存档-聊天详情

const isLocal = isValidIP(window.location.hostname);
const fayeUrl = isLocal ? process.env.FAYE_DOMAIN : SERVER.faye;
const fayeClient = new Faye.Client(fayeUrl, { timeout: 20 });

const Page = styled.div`
  width: 100%;
  height: 100%;
  background: #ecf0f4;
  display: flex;
  position: relative;
  overflow-x: hidden;
  ${({ globalStateShow }) => globalStateShow && `
    padding-top: 60px;
  `}
`;
const Content = styled.div`
  flex: 1;
  height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
    .ant-table-body:hover {
      &::-webkit-scrollbar {
        height: 8px!important;
        width: 4px!important;
    }
    }
  
  .ant-table-body::-webkit-scrollbar {
      height: 0!important;
      width: 0!important;
  }
 .traffic-common-table-class {
    .ant-table-body::-webkit-scrollbar {
      height: 0!important;
      width: 0!important;
    }
  }
`;
const HeaderTitle = styled.div`
  width: calc(100vw - 150px);
  position: absolute;
  z-index: 9999;
  
  .title-div{
    background: #E7F3FC;
    cursor: pointer;
    height: 8px;
  }

  .animation-div{
    transition: all 0.2s ease;
    font-size: 14px;
    color: #595959;
    text-align: center;
    background: #E7F3FC;
    line-height: 25px;
    position: relative;

    span{
      color: #FC8352;
      cursor: pointer;
    }

    img{
      width: 12px;
      height: 12px;
    }

    .down-circle{
      position: absolute;
      right: 40px;
      cursor: pointer;
      top: 8px;
    }
  }
`

const mapDispatchToProps = {
  modalFlag,
};

//从redux中拿企业信息的值
const mapStateToProps = (state) => {
  const {
    enterPriseInfo,
    globalState
  } = state;

  return {
    ...enterPriseInfo,
    ...globalState
  };
};

const RouteList = new Map([
  ["traffic-dashboard", "企微看板"],
  ["traffic-customer", "好友列表"],
  ["traffic-group", "客户群"],
  ["loss-reminder", "流失提醒"],
  ["delete-reminder", "删人提醒"],
  ["material", "文件库"],
  ["technique-list", "话术库"],
  ["interact-radar", "营销素材"],
  ["ai-create", "AI内容创作"],
  ["traffic-clue", "营销线索"],
  ["sidebar", "侧边栏"],
  ["market", "员工活码"],
  ["markets", "群活码"],
  ["welcome", "欢迎语"],
  ["group-welcome", "入群欢迎语"],
  ["conversation", "会话存档"],
  ["warnings", "违规提醒"],
  ["warning-detail", "违规提醒"],
  ["traffic-stat", "SCRM分析"],
  ["traffic-tool", "SCRM工具"],
  ["enterprise-wechat-assistant", "企微助手"],
  ["customer-detail", "好友详情"],
  ["group-detail", "客户群详情"],
  ["material-radar", "营销素材详情"],
  ["market-detail", "员工活码详情"],
  ["markets-detail", "群活码详情"],
  ["guidance", "企业信息配置"],
  ["standard-operating", "好友SOP"],
  ["group-operating", "群SOP"],
  ["message-reply-list", "超时未回复提醒"],
  ["batch-add-friend-list", "批量添加好友"],
  ["card-applet", "智能名片"],
  ["smart-code", "智能码"],
  ["smart-code-detail", "智能码详情"],
  ["mass-assistant-list", "群发助手"],
  ["mass-assistant-list", "群发助手"],
  ["mass-assistant-detail", "新增群发任务"]
])

const PcPage = (props) => {
  const { menuType, changeMenu, errorCode, globalState } = props;
  const globalStateShow = globalState.showMenu;
  const { pathname } = useLocation();
  let history = useHistory()
  const [visible, setVisible] = useState(false)
  const [styleHeight, setStyleHeight] = useState(0)

  //根据当前路由变化，改变页面标题
  useEffect(() => {
    let docTitle = RouteList.get(pathname.split('/')[1])
    document.title = docTitle ? docTitle : ""
  }, [pathname])

  // 群详情批量打标签弹窗状态
  const modalFlag = (res) => {
    props.modalFlag(() => {
      return Promise.resolve({
        success: true,
        data: {
          value: res,
        },
      });
    });
  };

  useUpdateEffect(() => {
    if (props.userInfo.uid) {
      const userUid = `/pc_group_label_group_${props.userInfo.uid}`; // faye订阅的频道
      fayeClient.subscribe(`${userUid}`, function (res) {
        modalFlag(res);
      });
      return () => {
        fayeClient.unsubscribe(`${userUid}`);
      };
    }
  }, [props.userInfo]);

  const resize = () => {
    let traffic = document.getElementById("traffic-container");
    const bodySet = document.querySelector(".body-set");
    if (bodySet) {
      traffic.style.height = bodySet.clientHeight + "px";
    }
  }

  useEffect(() => {
    let traffic = document.getElementById("traffic-container");
    const bodySet = document.querySelector(".body-set");
    if (bodySet) {
      traffic.style.height = bodySet.clientHeight + "px";
    }

    window.addEventListener('resize', resize);
    return (() => {
      window.removeEventListener('resize', resize)
    })
  }, [])

  useEffect(() => {
    //老客户配置过的全局提示
    if (props.enterPriseInfo.apiStatus && props.enterPriseInfo.jumpToAbf) {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }, [pathname, props.enterPriseInfo])

  return (
    <Page globalStateShow={globalStateShow} style={getParameterByName("deviceType") === "iframe" ? { overflowX: "auto", } : {}}
     className="lxui"
    /**会话存档嵌入crm时页面太小挤压出现问题，给出横向滚动条 */
    >
      {
        globalStateShow ? <MenuList changeMenu={changeMenu} menuType={menuType} /> : null
      }
      <ErrorModal errorCode={Number(errorCode)} />
      <Content id='traffic-content-id'>
        <HeaderTitle>
          {
            visible ? <div className="title-div" onClick={() => {
              if (styleHeight === 0) {
                setStyleHeight(32)
              } else {
                setStyleHeight(0)
              }
            }}>
            </div> : ""
          }

          <div className="animation-div" style={{ height: styleHeight }}>
            {styleHeight !== 0 ?
              <>
                <img src={TipsSolid} style={{ marginRight: "8px" }} alt="" />
                因企业微信账号ID安全性升级，您需要进行通讯录配置，否则可能导致员工账号不可用。
                <span onClick={() => {
                  history.push({ pathname: '/guidance', state: { url: `${pathname || '/enterprise-customer'}` } })
                }}>
                  去设置
                </span>
                <img src={DownCircle} alt="" className="down-circle" onClick={() => { setStyleHeight(0) }} />
              </> : ""}
          </div>
        </HeaderTitle>
        <Switch>
          <Route exact path="/" component={TrafficCustomer} />
          {/* 企微助手融合CRM，第一部分路由需判断企业是否需要第一次配置项，由home组件统一判断 */}
          <Route path="/traffic-customer" component={TrafficCustomer} />
          <Route path="/traffic-dashboard" component={EnterpriseBoard} />
          <Route path="/traffic-stat" component={CustomerAnalysis} />
          <Route path="/traffic-tool" component={ToolCenter} />
          <Route path="/traffic-group" component={GroupList} />
          <Route path="/qw-assistant" component={QwAssistant} />

          <Route path="/no-permission" component={NoPermission} />
          <Route path="/enterprise-customer" component={TrafficCustomer} />
          <Route path="/enterprise-board" component={EnterpriseBoard} />
          <Route path="/customer-analysis" component={CustomerAnalysis} />
          <Route path="/tool-center" component={ToolCenter} />
          <Route path="/group-list" component={GroupList} />
          <Route path="/guidance" component={Guidance} />
          <Route path="/markets" component={MarketGroup} />
          <Route path="/market" component={MarketStaff} />
          <Route path="/customer-detail" component={CustomerDetail} />
          <Route path="/welcome" component={Welcome} />
          <Route path="/group-welcome" component={GroupWelcome} />
          <Route path="/settings" component={Settings} />
          <Route path="/company" component={Company} />
          <Route path="/warnings" component={ViolationWarnings} />
          <Route path="/warning-detail" component={ViolationWarnings} />
          <Route path="/conversation" component={Conversation} />
          <Route path="/conversation-new" component={ConversationNew} />
          <Route path="/conversation-friend" component={ConversationFriend} />
          {/* <Route path="/conversation-friend" component={Conversation} /> */}
          <Route path="/open-information" component={OpenInformation} />
          <Route path="/message-guidance" component={MessageGuidance} />
          <Route path="/material" component={MaterialList} />
          <Route path="/material-radar" component={MaterialRadar} />
          <Route path="/sidebar" component={Sidebar} />
          <Route path="/group-detail" component={GroupDetail} />
          <Route path="/technique-list" component={TechniqueList} />
          <Route path="/technique-personal-list" component={TechniquePersonalList} />
          <Route path="/market-detail" component={MarketDetail} />
          <Route path="/markets-detail" component={MarketDetail} />
          <Route path="/loss-reminder" component={LossReminder} />
          <Route path="/delete-reminder" component={DeleteReminder} />
          <Route path="/interact-radar" component={InteractRadar} />
          <Route path="/ai-create" component={AICreate} />
          <Route path="/traffic-clue" component={MarketClues} />
          <Route path="/enterprise-wechat-assistant" component={QwAssistant} />
          <Route path="/standard-operating" component={SopList} />
          <Route path="/group-operating" component={SopList} />
          <Route path="/standard-operating-detail/:id" component={StandardOperatingDetail} />
          <Route path="/standard-operating-save/:id" component={StandardOperatingSave} />
          <Route path="/message-reply-list" component={MessageReplyList} />
          <Route path="/batch-add-friend-list" component={BatchAddFriendList} />
          <Route path="/card-applet" component={CardApplet} />
          <Route path="/smart-code" component={SmartCode} />
          <Route path="/smart-code-detail" component={SmartCodeDetail} />
          <Route path="/remind-customer-detail" component={RemindCustomerDetail} />
          <Route path="/mass-assistant-list" component={MassAssistantList} />
          <Route path="/mass-assistant-detail" component={MassAssistantDetail} />
          <Route path="/potential-leads" component={PotentialLeads} />
          <Route path="/traffic-batch-add-friend-detail" component={BatchAddFriendDetail} />
          <Route path="/traffic-batch-add-friend-detail/guide" component={BatchAddFriendGuide} />
          <Route path="/third-guide" component={ThirdGuide}></Route>
          <Route path='/third-conversation' exact={true} component={ThirdConversationList} />
          <Route path="/third-conversation/:id" exact={true} component={ThirdConversationUserDetailList}></Route>
          <Route path="/third-conversation/:id/:sessionId" exact={true} component={ThirdConversationChatDetailList}></Route>
            
          <Redirect to={"/TrafficCustomer"} />
        </Switch>
      </Content>
    </Page>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(PcPage);
